import { Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { CAROUSEL_SOCIAL } from '../../../../constants/UiBuilderConst';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import ViewAllSelector from '../../../../shared/ui-builder/view-all-selector/View-All-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//2E Social Component
const CarouselSocialComponent = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;

  const initialSlide = [
    {
      id: `slide_1`,
      label: `Slide 1`,
      imgURL: null,
      redirectLinkUri: '',
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_2`,
      label: `Slide 2`,
      imgURL: null,
      redirectLinkUri: '',
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_3`,
      label: `Slide 3`,
      imgURL: null,
      redirectLinkUri: '',
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_4`,
      label: `Slide 4`,
      imgURL: null,
      redirectLinkUri: '',
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
  ];
  const addNewSlide = {
    id: '',
    label: '',
    imgURL: null,
    redirectLinkUri: '',
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [viewAll, setViewAll] = useState(
    config?.viewAll ? config.viewAll : { isActive: true, linkId: '' },
  );
  const [h2Title, setH2Title] = useState(config.titleH2 || '');
  const [error, setError] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState(
    config.backgroundColor ? config.backgroundColor : '#8f8f8f',
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);
  const maxSlidesCount = 20;

  useEffect(() => {
    onItemChange({
      componentName: CAROUSEL_SOCIAL,
      config: {
        titleH2: h2Title,
        backgroundColor: backgroundColor,
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  }, [slidesList, h2Title, backgroundColor, viewAll, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === CAROUSEL_SOCIAL,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type && val?.value) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field) => {
    const thisErr = setErrorField(field, val);

    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisErr } : prev;
    });

    const newConfigErr = { ...error?.config };

    setError({ config: newConfigErr, slides: newSlidesErr });

    switch (field) {
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'redirectLinkUri':
        slideContent.redirectLinkUri = val;
        break;
      case 'viewAll':
        setViewAll({
          ...viewAll,
          linkId: val,
        });
        break;
      case 'viewAllStatus':
        setViewAll({
          ...viewAll,
          isActive: val,
        });
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      default:
        break;
    }
    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const onChangeH1 = (e) => {
    const titleError = setErrorField('titleH2', e);
    setError({
      config: { ...error?.config, titleH2: titleError },
      slides: error?.slides || [],
    });
    setH2Title(e);
  };

  const hasError = (key, isReturnString) => {
    const hasSliderError = error?.slides?.find((errorSlider) => {
      return (
        errorSlider?.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl')
      );
    });
    if (isReturnString && hasSliderError && key === 'videoURL') return hasSliderError?.videoURL;
    if (isReturnString && hasSliderError && key === 'redirectLinkUri')
      return hasSliderError?.redirectLinkUri;
    if (hasSliderError) return true;
    return false;
  };

  const onColorChange = (color) => {
    setBackgroundColor(color);
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      addNewSlide.id = `slide_${slidesList.length + 1}`;
      addNewSlide.label = `Slide ${slidesList.length + 1}`;
      tempSlidesList.push(addNewSlide);
      setSlidesList(tempSlidesList);
      setActveTabIndex(tempSlidesList.length - 1);
      setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActveTabIndex(tempSlidesList.length - 1);
        setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
      } else {
        setActveTabContent(tempSlidesList[activeTabIndex]);
      }
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    onItemChange({
      componentName: CAROUSEL_SOCIAL,
      config: {
        titleH2: h2Title,
        backgroundColor: backgroundColor,
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  };

  return (
    <>
      <div className='row my-2 mx-4'>
        <div className='col-md-10'>
          <div className='col-md-12 background-color-titleH2 mb-2'>Background Color</div>
          <div
            className='color-preview d-flex justify-content-center align-items-center shadow mb-4'
            style={{ backgroundColor: backgroundColor }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          >
            <span className='color-preview-label'>{backgroundColor}</span>
          </div>
          <CustomUiBuilderTextField
            label='H2 Title'
            required={true}
            className='col-md-12'
            value={h2Title}
            onChangeInput={(e) => onChangeH1(e.target.value)}
            maxLength={100}
            isAdornment={true}
            endAdornment={true}
            error={!isSwapEnabled && error?.config?.titleH2 === 'required'}
          />
          <div className='row mt-4 mb-3'>
            <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
              <DraggableTabsList
                onDragEnd={onDragEnd}
                tabs={slidesList}
                onTabChange={onTabChange}
                activeTabIndex={activeTabIndex}
              />
              <div className='ms-2'>
                <Button
                  disabled={slidesList.length >= maxSlidesCount}
                  variant='outlined'
                  size='medium'
                  color='secondary'
                  onClick={(e) => AddNewSlide(e)}
                >
                  <Add />
                </Button>
              </div>
            </div>
            <div className='col-md-12 mt-3'>
              <div className='col-md-12'>
                <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
                  <div>Slide {activeTabContent?.id?.split('_')[1]}</div>
                  <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
                    Remove
                  </div>
                </div>
                <div className='col-md-12 mt-4'>
                  <MediaSelector
                    groupId={groupId}
                    titleH2={'Image'}
                    height={280}
                    width={280}
                    matrix={'px'}
                    handleTabData={handleTabData}
                    activeTabContent={activeTabContent}
                    isSwapEnabled={isSwapEnabled}
                    setIsSwapEnabled={setIsSwapEnabled}
                    hasError={hasError}
                    ratio={'1:1'}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <p className='redirect-title'>Redirect Link</p>
                  <CustomUiBuilderTextField
                    label='Enter Link'
                    className='col-md-12'
                    value={activeTabContent.redirectLinkUri}
                    maxLength={'2048'}
                    onChangeInput={(e) =>
                      handleTabData(e.target.value, activeTabContent, 'redirectLinkUri')
                    }
                    multiline={true}
                    error={!isSwapEnabled && hasError('redirectLinkUri')}
                    errorType={!isSwapEnabled && hasError('redirectLinkUri', true)}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <ViewAllSelector
                    onValueChange={(e) => handleTabData(e, activeTabContent, 'viewAll')}
                    value={viewAll.linkId}
                    onViewAllStatusChange={(e) => {
                      handleTabData(e, activeTabContent, 'viewAllStatus');
                    }}
                    isActive={viewAll.isActive}
                    isRequired={viewAll.isActive ? true : false}
                    error={
                      !isSwapEnabled &&
                      viewAll.linkId === '' &&
                      error?.config?.viewAll === 'required'
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={backgroundColor}
          onColorChange={onColorChange}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default CarouselSocialComponent;
